<style lang="scss" scoped>
.search-results {
    .loading {
        display: flex;
        flex: 1;
        text-align: center;
        justify-content: center;
        align-items: center;
        min-height: 468px;
    }

    .component-fade-enter-active,
    .component-fade-leave-active {
        transition: opacity 0.3s ease;
    }
    .component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
}
</style>

<template>
    <div class="search-results">
        <transition name="component-fade" mode="out-in">
            <div v-if="ready" key="ready">
                <product-rows v-if="products.length > 0" :products="products">
                    <slot></slot>
                </product-rows>
                <p v-else>Geen producten gevonden</p>
            </div>
            <div key="loading" v-else class="loading">
                <spinner></spinner>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "Ui.SearchResults",

    props: {
        searchTerm: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            ready: false,
            products: []
        };
    },

    mounted() {
        const self = this;

        var promise = this.getProducts(this.searchTerm);

        promise.then(
            function() {
                self.ready = true;
            },
            function(error) {
                console.log(error);
            }
        );
    },

    methods: {
        getProducts(searchTerm) {
            const self = this;

            return new Promise(function(resolve, reject) {
                axios
                    .get(`/api/search?product=${searchTerm}`)
                    .then(function(response) {
                        self.products = Object.values(response.data.products);
                        resolve(response.data);
                    })
                    .catch(function(error) {
                        reject(error);
                    });
            });
        }
    }
};
</script>
